/** Display-only hints map to fixed destinations, never to a caller-supplied URL. */
export const CHAT_CLIENTS = [
   { id: 'chatgpt', label: 'Back to ChatGPT', href: 'https://chatgpt.com/' },
   { id: 'claude', label: 'Back to Claude', href: 'https://claude.ai/' },
] as const

export function clientReturnLinks(search: string) {
   const hints = new URLSearchParams(search).getAll('mcpClient')
   // Older calendar callbacks appended a second '?' to the last query value.
   // Recover only that exact display-only suffix, never arbitrary trailing input.
   const hint = hints.length === 1 ? hints[0].replace(/\?calendarConnected=true$/, '') : undefined
   const match = CHAT_CLIENTS.find(client => client.id === hint)
   return match ? [match] : CHAT_CLIENTS
}
